<template>
  <v-row ref="editForm"
         class="edit-form edit-bank-form"
         no-gutters>

    <v-col cols="12"
           sm="6">
      <v-text-field v-model="userForm.ktoiban"
                    v-validate="{ required: true, 'iban-validator': true }"
                    :error-messages="errors.collect('iban')"
                    data-vv-as="IBAN"
                    name="iban"
                    label="IBAN"
                    placeholder="DE00 0000 0000 0000 0000 00"
                    mask="AA## #### #### #### #### #### #### #### #### #####"
                    class="required"
                    autocorrect="off"
                    spellcheck="false" />
    </v-col>

    <v-col cols="12"
           sm="6">
      <template v-if="$helpers.isIbanAusland(userForm.ktoiban)">
        <v-text-field v-model="userForm.ktobic"
                      v-validate="'required|bic-validator'"
                      :error-messages="errors.collect('bic')"
                      data-vv-as="BIC"
                      name="bic"
                      label="BIC"
                      hint="Bitte geben Sie für ausländische Konten die BIC ein."
                      class="required" />
      </template>
    </v-col>

    <v-col class="custom-label-radiogroup"
            cols="12">
      <v-row no-gutters>

        <v-col cols="12"
               sm="6">
          <div>Vermittler ist Kontoinhaber?</div>
        </v-col>

        <v-col :class="$vuetify.breakpoint.smAndUp ? 'pl-10' : 'pt-4'"
                cols="12"
                sm="6">

          <v-radio-group v-model="userForm.ktoinhaberanderer"
                         hide-details
                         row>
            <v-radio label="Ja"
                     value="0"
                     color="primary" />
            <v-radio label="Nein"
                     value="1"
                     color="primary" />
          </v-radio-group>

        </v-col>
      </v-row>
    </v-col>

    <template v-if="userForm.ktoinhaberanderer === '1'">

      <v-col id="kontoinhaber"
              class="semanticsection-title2 primary--text"
              cols="12">Kontoinhaber
      </v-col>

      <v-col cols="12"
             sm="11">
        <v-radio-group v-model="userForm.ktoinhaberanrede"
                       hide-details
                       row>
          <v-radio label="Frau"
                   value="Frau"
                   color="primary" />
          <v-radio label="Herr"
                   value="Herr"
                   color="primary" />
          <v-radio label="keine Angabe"
                   value="kA"
                   color="primary" />
        </v-radio-group>
      </v-col><v-col cols="0" sm="1"/>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model.trim="userForm.ktoinhabervorname"
                      v-validate="{ required: true, regex: /[^0-9!§$%&\/()=?#*+{\[\]}]{2,}$/ }"
                      :error-messages="errors.collect('firstname')"
                      data-vv-as="Vorname"
                      class="required"
                      name="firstname"
                      label="Vorname" />
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model.trim="userForm.ktoinhabernachname"
                      v-validate="{ required: true, regex: /[^0-9!§$%&\/()=?#*+{\[\]}]{2,}$/ }"
                      :error-messages="errors.collect('lastname')"
                      data-vv-as="Nachname"
                      class="required"
                      name="lastname"
                      label="Nachname" />
      </v-col>
    </template>

  </v-row>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import plzOrtMixin from "@/components/helper/plzOrtMixin";
import REGEX from "@/validation/regexes";

export default {
  name: "EditBank",
  mixins: [ValidationMixin, plzOrtMixin],
  props: {
    userForm: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      ort: "",
      regex: REGEX
    };
  },
  watch: {
    // ort watcher and field in data used to set ktoinhaberort because plzOrtMixin expects the field to be named ort
    ort: function (newOrt) {
      this.userForm.ktoinhaberort = newOrt;
    }
  }
};
</script>
<style>
.edit-bank-form .custom-label-radiogroup .v-input {
  padding-top: 0 !important;
}

.edit-bank-form .custom-label-radiogroup .row > div:first-child {
  padding-top: 2px;
}

.edit-bank-form #kontoinhaber.semanticsection-title2 {
  margin-top: 40px !important;
}
</style>
